import { render, staticRenderFns } from "./itemImage.vue?vue&type=template&id=4a0322b8&scoped=true&"
import script from "./itemImage.vue?vue&type=script&lang=js&"
export * from "./itemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0322b8",
  null
  
)

export default component.exports